module.exports = __webpack_public_path__ + "static/media/pricingPage2.c9473430.png";